import EveryoneIcon from 'assets/icons/buttons/everyone.svg';
import JustMeIcon from 'assets/icons/buttons/lock.svg';
import CustomIcon from 'assets/icons/buttons/custom.svg';
import AdminIcon from 'assets/icons/buttons/admin.svg';
import ClientIcon from 'assets/icons/buttons/client.svg';
import EmployeeIcon from 'assets/icons/buttons/employee.svg';

import { PostVisibilityEnum } from 'redux-store/api/activity-feed';

export const ICONS_MAP = {
  [PostVisibilityEnum.EVERYONE]: <EveryoneIcon />,
  [PostVisibilityEnum.JUST_ME]: <JustMeIcon />,
  CUSTOM: <CustomIcon />,
  ADMIN: <AdminIcon />,
  CLIENT: <ClientIcon />,
  EMPLOYEE: <EmployeeIcon />,
};
